var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#59595C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-679 -265) translate(679 266) translate(8.26 11) translate(0 .311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.045 30.822l-17.48-29.43C23.047.522 22.12 0 21.084 0c-1.036 0-1.964.52-2.481 1.393l-17.48 29.43c-.518.871-.518 1.913 0 2.784C1.64 34.48 2.568 35 3.604 35h34.96c1.035 0 1.963-.52 2.48-1.393.519-.871.519-1.913 0-2.785zm-2.068 1.625c-.051.087-.174.232-.413.232H3.604c-.24 0-.362-.145-.413-.232-.052-.087-.12-.262 0-.464l17.48-29.43c.12-.202.31-.232.413-.232.103 0 .293.03.413.232l17.48 29.43c.12.202.051.377 0 .464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.301 10.652H22.648999999999997V22.826H20.301z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.084,
    cy: 26.63,
    rx: 1.565,
    ry: 1.522
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailRequest);
export default __webpack_public_path__ + "static/media/fail-request.f21d176d.svg";
export { ForwardRef as ReactComponent };